import withSummaryWidget from "./withSummaryWidget";

export default {
  withSummaryWidget
};
